import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const VIASAPTRANSPORT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ViaSAPTransport.Name')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('value', 'Entity.ViaSAPTransport.Value')
    .required()
    .maxLength(50)
    .build(),
];

export const VIASAPTRANSPORT_CONFIG = {
  entityName: 'ViaSapTransport',
  localizationKey: 'Controlling::Entity.ViaSAPTransport',
  fields: VIASAPTRANSPORT_FIELDS,
  permission: 'ControllingLiquidations.ViaSapTransports',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
